import { BidStatus, type BidDto } from "../../../../../autogen/bff-api";

export const isReadonlyBidStatus = (status: BidStatus): boolean =>
  status === BidStatus.Submitted ||
  status === BidStatus.Awarded ||
  status === BidStatus.Rejected;

type LockFields = Pick<BidDto, "status" | "submissionDeadlinePassed" | "signedDocumentId">;

export const isBidLockedByDeadline = (bid: LockFields): boolean =>
  bid.status === BidStatus.Draft && bid.submissionDeadlinePassed === true && bid.signedDocumentId == null;

export const isSubmittedBidLockedByDeadline = (bid: LockFields): boolean =>
  bid.status === BidStatus.Submitted && bid.submissionDeadlinePassed === true;

export const showsReadonlyBid = (bid: LockFields): boolean =>
  isReadonlyBidStatus(bid.status) || isBidLockedByDeadline(bid);
